<template>
	<div
		class="d-flex flex-column justify-center align-center"
		style="
			background-color: #d2d6de;
			background-size: cover;
			background-attachment: fixed;
			min-height: 100vh;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		"
	>
		<v-form ref="form" v-if="showLoginForm && isAdministrator" v-model="valid" @submit.prevent="login">
			<v-card width="360">
				<v-card-title class="title d-flex justify-center align-center mb-4" style="background-color: #003366; color: white">
					<v-img max-width="150" :src="baseLocation + '/resource/image/v-unite-logo.png'"></v-img>
				</v-card-title>
				<v-card-text>
					<v-text-field v-model="email" :rules="emailRules" label="E-mail" required></v-text-field>
					<v-text-field
						v-model="password"
						:rules="passwordRules"
						:type="passwordFieldType"
						:append-icon="passwordFieldType === 'password' ? 'mdi-eye' : 'mdi-eye-off'"
						@click:append="switchVisibility"
						label="Password"
						required
						@keyup.enter="login"
					></v-text-field>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions class="py-4">
					<v-spacer></v-spacer>
					<v-btn :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Login</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>

		<v-form ref="form" v-model="valid" @submit.prevent="validateEmail" v-if="showLoginForm && !isAdministrator">
			<v-card width="360">
				<v-card-title class="title d-flex justify-center align-center mb-4" style="background-color: #003366; color: white">
					<v-img max-width="150" :src="baseLocation + '/resource/image/v-unite-logo.png'"></v-img>
				</v-card-title>
				<v-card-text>
					<v-text-field
						v-model="email"
						:rules="emailRules"
						label="E-mail"
						required
						validate-on-blur
						@keyup.enter="validateEmail"
					></v-text-field>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions class="py-4">
					<v-spacer></v-spacer>
					<v-btn type="submit" color="primary darken-1" depressed tile>Next</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>

		<v-form ref="form" v-model="valid" @submit.prevent="validatePassword" v-if="showPasswordForm">
			<v-card width="360">
				<v-card-title class="title d-flex justify-center align-center mb-4" style="background-color: #003366; color: white">
					<v-img max-width="150" :src="baseLocation + '/resource/image/v-unite-logo.png'"></v-img>
				</v-card-title>
				<v-card-text>
					<v-radio-group v-model="tenantId" v-if="tenantStaffList.length > 1">
						<v-radio v-for="(tenant, idxTenant) in tenantStaffList" :key="idxTenant" :value="tenant.id" :label="tenant.name">
						</v-radio>
					</v-radio-group>
					<v-text-field
						v-model="password"
						:rules="passwordRules"
						:type="passwordFieldType"
						:append-icon="passwordFieldType === 'password' ? 'mdi-eye' : 'mdi-eye-off'"
						@click:append="switchVisibility"
						label="Password"
						required
						validate-on-blur
						@keyup.enter="validatePassword"
					></v-text-field>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions class="py-4">
					<v-spacer></v-spacer>
					<v-btn type="submit" color="primary darken-1" depressed tile>Login</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>

		<v-form ref="form" v-model="valid" @submit.prevent="chooseExperience" v-if="showChooseExperienceForm">
			<v-card width="360">
				<v-card-title class="title d-flex justify-center align-center mb-4" style="background-color: #003366; color: white">
					<v-img max-width="150" :src="baseLocation + '/resource/image/v-unite-logo.png'"></v-img>
				</v-card-title>
				<v-card-text>
					<span><h2>Choose Experience :</h2></span>
					<div style="max-height: 300px; overflow: auto; margin-top: 5px">
						<v-radio-group v-model="experienceId">
							<v-radio
								v-for="(experience, idxExperience) in experienceList"
								:key="idxExperience"
								:value="experience.id"
								:label="experience.name"
							>
							</v-radio>
						</v-radio-group>
					</div>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions class="py-4">
					<v-spacer></v-spacer>
					<v-btn type="submit" color="primary darken-1" depressed tile>Next</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>

		<div v-if="showPermissionForm">
			<v-card width="360">
				<v-card-title class="title d-flex justify-center align-center mb-4" style="background-color: #003366; color: white">
					<v-img max-width="150" :src="baseLocation + '/resource/image/v-unite-logo.png'"></v-img>
				</v-card-title>
				<v-card-text>
					<span style="font-size: 18px; color: black"
						><strong>{{ email }}</strong> would like to:</span
					>
					<div v-for="(scope, idxScope) in scopeList" :key="idxScope">
						<span v-if="scope" style="font-size: 14px; color: black"><v-icon>mdi-circle-small</v-icon>{{ scope }}</span>
					</div>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions class="py-4">
					<v-spacer></v-spacer>
					<v-btn type="submit" style="border: 1px solid #001e4e" @click="allow('NO')" depressed tile>cancel</v-btn>
					<v-btn type="submit" color="primary darken-1" @click="allow('YES')" depressed tile>allow</v-btn>
				</v-card-actions>
			</v-card>
		</div>
	</div>
</template>

<script>
import axios from "axios";

export default {
	data() {
		return {
			valid: true,
			email: "",
			emailRules: [(v) => !!v || "E-mail is required", (v) => /.+@.+\..+/.test(v) || "E-mail must be valid"],
			password: "",
			passwordRules: [(v) => !!v || "Please specify password"],
			baseLocation: axios.defaults.baseURL,
			tenantStaffList: [],
			tenantId: null,
			showLoginForm: true,
			showPasswordForm: false,
			showChooseExperienceForm: false,
			showPermissionForm: false,
			passwordFieldType: "password",
			experienceList: [],
			experienceId: null,
			scopeList: [],
			isAdministrator: false
		};
	},
	mounted() {
		if (this.$route.query.user_role === "Administrator" || this.$route.query.user_role === "Tenant_Staff") {
			this.isAdministrator = this.$route.query.user_role === "Administrator";
		} else {
			location.href = "/#/404";
		}
	},
	methods: {
		login() {
			axios
				.post("/system/oauth/user/check", {
					email: this.email,
					password: this.password,
					tenantId: this.tenantId,
					user_role: this.$route.query.user_role
				})
				.then((response) => {
					if (response.data) {
						this.$refs.form.resetValidation();
						if (this.isAdministrator) {
							this.findClient();
							this.showPermissionForm = true;
							this.showLoginForm = false;
						} else {
							this.listExperience();
							this.showChooseExperienceForm = true;
							this.showPasswordForm = false;
						}
					}
				})
				.catch(() => {});
		},
		check() {
			axios
				.get("/system/oauth/authorize/check")
				.then((response) => {
					if (!response.data) {
						location.href = "/#/404";
					}
				})
				.catch(() => {});
		},
		listExperience() {
			axios
				.get("/system/authentication/experience/list?tenantId=" + this.tenantId)
				.then((response) => {
					this.experienceList = response.data;
				})
				.catch(() => {});
		},
		allow() {
			axios
				.post("/system/oauth/authorize", {
					scope: ["add_user_experience", "update_user_experience"],
					approval_status: status,
					experience_id: this.experienceId,
					resolved_redirect_uri: encodeURIComponent(this.$route.query.resolved_redirect_uri),
					response_type: this.$route.query.response_type,
					state: this.$route.query.state,
					client_id: this.$route.query.client_id,
					tenant_id: this.tenantId,
					email: this.email,
					user_role: this.$route.query.user_role
				})
				.then((response) => {
					top.window.location = response.data;
				})
				.catch(() => {});
			return false;
		},
		next() {
			axios
				.get("/system/authentication/tenant/list?email=" + this.email)
				.then((response) => {
					this.tenantStaffList = response.data;
					if (this.tenantStaffList.length == 1) {
						this.tenantId = this.tenantStaffList[0].id;
					}
					this.$refs.form.resetValidation();
					this.showLoginForm = false;
					this.showPasswordForm = true;
				})
				.catch(() => {});
		},
		chooseExperience() {
			this.showChooseExperienceForm = false;
			this.findClient();
			this.showPermissionForm = true;
		},
		findClient() {
			axios
				.get("/system/authentication/oauthClient/scope/list?clientId=" + this.$route.query.client + "&user_role=" + this.$route.query.user_role)
				.then((response) => {
					this.scopeList = response.data;
				})
				.catch(() => {});
		},
		switchVisibility() {
			this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
		},
		validateEmail() {
			this.$refs.form.validate();
			if (this.valid) {
				this.next();
			}
		},
		validatePassword() {
			this.$refs.form.validate();
			if (this.valid) {
				this.login();
			}
		}
	}
};
</script>